module.exports = __webpack_public_path__ + "img/knu2_gallery5.ad1a3524.jpg";